function equalizer(){
  var max = -1;
  $(".services_box").css('min-height', 'auto'); 	
  $('.services_box').each(function() {

    var minHeight = $(this).innerHeight();
    max = minHeight > max ? minHeight : max;

  });  
  $(".services_box").css('min-height',max); 
  
  var max = -1;
  $(".product_grid").css('min-height', 'auto'); 	
  $('.product_grid').each(function() {

    var minHeight = $(this).innerHeight();
    max = minHeight > max ? minHeight : max;

  });  
  $(".product_grid").css('min-height',max); 
}

function coll_grid() {
  if( $(window).width() < 768 ) {
    $('.grid_content').BlocksIt({
      numOfCol: 2,
      offsetX: 0,
      offsetY: 0
    });
  } else {
    $('.grid_content').BlocksIt({
      numOfCol: 4,
      offsetX: 0,
      offsetY: 0
    });
  }
}

$( window ).on("load", function() {
  coll_grid();
  equalizer();
});

$(window).resize(function() {
  coll_grid();
  equalizer();
});


$(document).ready(function() {

  equalizer();

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 1) {
      $('header').addClass('stickytop');
    }
    else {
      $('header').removeClass('stickytop');
    }
  });

  $('.shoppingCart, .closeCart').on('click', function() {   
    $('body').toggleClass('CartOpen');
    return false;
  });

  
  $('.quotes_slider').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '5px',
    slide: 'li',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          centerPadding: '100px',
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerPadding: '0px',
        }
      }
    ]
  });
  
  $('.article_slider').slick({
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1, 
    centerMode: false,
     centerPadding: '0px',
    slide: 'li',
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  
  
  
//   $('.product-for').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     fade: true,
//     infinite: false,
//     dots: false,
//     adaptiveHeight:true,
//     slide:'li'
//   });
  
  
  
  
  
  
  $('.product-for').slick({
    slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	slide:'li',
	infinite: false,
    asNavFor: '.product-nav',
    slide:'li'
  });

  $('.product-nav').slick({
    slidesToShow:4,
    slidesToScroll: 1,
    asNavFor: '.product-for',
    dots: false,
    arrows: false,
    infinite: true,
    focusOnSelect: true,
    vertical:true,
    responsive: [
      {
        breakpoint: 1199,
        settings:{
          slidesToShow: 3
        }
      },
      {
        breakpoint: 640,
        settings:{
          vertical:false,
          slidesToShow: 4
        }
      },
    ]
  });
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  $('.related_product ul').slick({
	  //infinite: true,
	  arrows: true,
	  dots: false,
	  slidesToShow: 4,
	  slidesToScroll: 1,
	  slide: 'li',
	  autoplay: false,
	  responsive: [
		{
		  breakpoint: 992,
		  settings: {
			slidesToShow: 3,
		  }
		},
		{
		  breakpoint: 768,
		  settings: {
			slidesToShow: 2,
		  }
		},
		{
		  breakpoint: 641,
		  settings: {
			slidesToShow: 1,
		  }
		}
	  ]
	});

  if( $(window).width() < 1024 ) {
    $('.mobile_toggle_link').on('click', function() {    
      $('h5.mobile_toggle_link').removeClass('active');
      $('.mobile_toggle').slideUp();
      if( $(this).next('.mobile_toggle').is(":visible") ){ 
        $(this).next('.mobile_toggle').slideUp();
        $(this).removeClass('active');
      } else {
        $(this).next('.mobile_toggle').slideDown();
        $(this).addClass('active');
      }
    });
  }
  
  $('.cart_qty .minus').on('click', function() {
    var count = $(this).siblings(".cart_input");
    var val = parseInt(count.val());
    if (val > 1)
      count.val(val - 1);
  });

  $('.cart_qty .plus').on('click', function() {
    var count = $(this).siblings(".cart_input");
    var val = parseInt(count.val());
    count.val(val + 1); 
  });
  
  $('.product_tabs li:first-child').find('a').addClass('active');
  $('.product_tabs .tab-content .tab-pane:first-child').addClass('in active');
  
  
  var maxHeight = 0;

  $(".product_grid_detail h6").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".product_grid_detail h6").height(maxHeight);
  
  $(".desc_boxes li").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".desc_boxes li").height(maxHeight);
  
  
  $(".ba_wrap").each(function(){
    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
  });
  $(".ba_wrap").height(maxHeight);
  
  
});
 
/* accoradian */

$(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    var links = this.el.find('.article-title');
    links.on('click', {
      el: this.el,
      multiple: this.multiple
    }, this.dropdown)
  }

  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
    $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.accordion-content').not($next).slideUp().parent().removeClass('open');
    };
  }
  var accordion = new Accordion($('.accordion-container'), false);
});

var $li = $('.content-entry'),
    half = Math.floor($li.length/2);

$li.filter(function(i){ return i <= half; }).wrapAll('<div class="half_wcs">');
$li.filter(function(i){ return i > half; }).wrapAll('<div class="half_wcs">');